import React, { useEffect, useState } from "react";
import "./Searchnav.css";
import WelcomeName from "./WelcomeName";
import HomeIcon from "@mui/icons-material/Home";
import { IconButton } from "@mui/material";
import NewReleasesIcon from "@mui/icons-material/NewReleases";
import ReleaseNotesPopup from "./ReleaseNotesPopup";
import Alert from "@mui/material/Alert";
import CloseIcon from "@mui/icons-material/Close";
import DescriptionIcon from "@mui/icons-material/Description";
import { useMsal } from "@azure/msal-react";

function Searchnav({ allReset, setAllReset }) {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  // const [openAlert, setOpenAlert] = React.useState(false);

  const togglePopup = () => {
    setIsPopupOpen(!isPopupOpen);
  };

  const { instance } = useMsal();
  const activeAccount = instance.getActiveAccount();
  let loggedInEnterpriseId = "";
  if (activeAccount)
    loggedInEnterpriseId = activeAccount.idTokenClaims.enterpriseID;

  const allowedUsersForContibution = [
    "ankur.e.mishra",
    "h.srinivasan",
    "jeevadharani.ramanan",
    "reshmi.haridas.m",
    "aayushi.bharti",
    "varsha.a.tyagi",
    "d.d.choudhary",
    "lakshay.c.gupta"
  ];

  return (
    <>
      <div class="searchnav-container">
        <div class="searchnav-wrap">
          <div class="searchnav-row">
            <div class="searchnav-box">
              {/* <img
        src={process.env.PUBLIC_URL + "/Images/Acc_Logo_Black_Purple_RGB.png"}
        class="acc-logo"
        alt="logo"
       /> */}
              <img
                src={process.env.PUBLIC_URL + "/Images/Acc_Logo.png"}
                className="acc_logo_new"
                alt="logo"
              />
              <p class="desktop-tag">
                {/* <span>Learning and Knowledge Management</span> <br /> <span className="comms">CommsBuilder</span> */}
                {/* comms_header */}
                <div className="comms-header-container">
                  <img
                    src={process.env.PUBLIC_URL + "/Images/comms_header.png"}
                    className="comms_header_img"
                    alt="logo"
                  />
                  <span>CommsBuilder</span>
                </div>
              </p>
              <IconButton
                sx={{ color: "white" }}
                onClick={() => setAllReset(!allReset)}
              >
                <HomeIcon />
              </IconButton>
              {allowedUsersForContibution.includes(loggedInEnterpriseId) && (
                <>
                  <div className="separator"></div>
                  <div className="release-popup-container">
                    <DescriptionIcon
                      sx={{ color: "white", cursor: "pointer" }}
                      onClick={togglePopup}
                    />

                    <ReleaseNotesPopup
                      isOpen={isPopupOpen}
                      onClose={togglePopup}
                    >
                      <h2>Popup Title</h2>
                      <p>This is the content of the popup.</p>
                    </ReleaseNotesPopup>
                  </div>
                </>
              )}
              <p class="mobile-tag">
                <span>LKM</span> <br /> SI
              </p>
            </div>
          </div>

          <div class="searchnav-row">
            <div
              class="searchnav-box"
              //   style={{ textAlign: "right", marginTop: "10px" }}
            >
              <p>Learning & Talent Transformation</p>
              {/* <p>Hello {localStorage.getItem("empName")}!</p> */}
              {/* <p>Hello !</p> */}
              {/* <WelcomeName /> */}
            </div>
          </div>
        </div>
      </div>
      <hr />
    </>
  );
}

export default Searchnav;
